import { useTranslation as _useTranslation } from "react-i18next";

import en from "../locales/en.i18n.json";

// Helper type to recursively create the "key1.key2.key3" type from the nested object
type NestedKeys<T> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ? `${K}.${NestedKeys<T[K]>}`
          : `${K}`
        : never;
    }[keyof T]
  : "";

// Define Translation type using the structure of the `en` object
export type Translation = NestedKeys<typeof en>;

/**
 * Adding a prefix capability so it's
 * eeasier to be backward compatible with
 * the legacy codebase
 */
export default function useTranslation(prefix = "") {
  const { t } = _useTranslation();
  return (key: Translation, options?: Record<string, unknown>) =>
    t(`${prefix ? `${prefix}.` : ""}${key}`, options);
}
